import type { NewsItem } from '@/types/content';

export const newsList: NewsItem[] = [
  {
    id: 1,
    title: '《星海远征》上映首周票房破8亿，国产科幻再迎高光时刻',
    subtitle: '视效与情感双线并进，观众口碑持续走高',
    category: '电影资讯',
    date: '2026-09-18',
    author: '影视仓编辑部',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20film%20premiere%20scene%2C%20glowing%20nebula%20and%20space%20imagery%20on%20a%20large%20screen%2C%20deep%20navy%20and%20teal%20tones%2C%20editorial%20photography%20style%2C%20landscape%20composition&width=800&height=500&seq=news-1&orientation=landscape',
    summary:
      '上映首周，《星海远征》以破8亿的票房成绩刷新了国产科幻电影的开画纪录，社交平台上关于影片视听语言的讨论热度居高不下。',
    content: [
      '由陈立川执导的科幻冒险电影《星海远征》上映首周便交出了一份亮眼成绩单，累计票房突破8亿元，成为今年国产科幻题材中开画表现最强劲的作品。',
      '影片讲述了一支远征队穿越虫洞寻找人类新家园的故事。业内评价认为，该片在宏大宇宙观与个体情感之间找到了较为平衡的表达方式，让硬核科幻落地到"人"的选择之上。',
      '不少观众在映后表示，影片后半段关于"家"的段落是全片情感浓度最高的部分。"它没有一味追求视觉奇观，而是在星海里讲了很人类的故事。"一位观众在社交平台写道。',
      '据片方透露，影片目前已在多个海外市场确定档期，后续还将推出幕后纪录特辑，进一步呈现视效团队长达三年的制作历程。',
    ],
  },
  {
    id: 2,
    title: '悬疑剧《长夜将至》口碑封神，第二季确认续订',
    subtitle: '剧本打磨四年，观众直呼"每一集都在反转"',
    category: '剧集动态',
    date: '2026-09-14',
    author: '林观影',
    cover:
      'https://readdy.ai/api/search-image?query=Moody%20noir%20crime%20drama%20scene%2C%20rainy%20city%20street%20at%20night%20with%20warm%20streetlight%20glow%2C%20deep%20blue%20and%20amber%20tones%2C%20cinematic%20editorial%20photography%2C%20landscape%20composition&width=800&height=500&seq=news-2&orientation=landscape',
    summary:
      '凭借缜密的剧本与克制的叙事，《长夜将至》在收官后依然稳居口碑榜前列，平台已正式宣布续订第二季。',
    content: [
      '悬疑犯罪剧《长夜将至》日前迎来收官，凭借层层递进的叙事与扎实的人物塑造，该剧在多个评分平台稳居前列，被不少剧迷称为"今年的悬疑标杆"。',
      '编剧苏晚在采访中透露，整个故事大纲经历了四年打磨，光是结尾就推翻了七个版本。"我们不想靠巧合推进剧情，每一个反转都必须对得起观众回看时的目光。"',
      '剧集播出期间，关于"谁是真正的凶手"的讨论多次登上话题榜。有趣的是，不少观众在二刷时发现，真凶的线索其实早已藏在第一集的画面细节之中。',
      '平台方随后确认，《长夜将至》第二季已进入开发阶段，原班主创有望回归，新一季将把视角延展到更广阔的小镇群像。',
    ],
  },
  {
    id: 3,
    title: '国产古装大剧《风起长安》定档，服化道细节引发考据热',
    subtitle: '四年筹备，还原盛唐气象',
    category: '剧集动态',
    date: '2026-09-10',
    author: '影视仓编辑部',
    cover:
      'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20scene%20at%20night%20with%20warm%20lanterns%20and%20elegant%20architecture%2C%20golden%20and%20deep%20red%20tones%2C%20refined%20editorial%20photography%2C%20landscape%20composition&width=800&height=500&seq=news-3&orientation=landscape',
    summary:
      '《风起长安》正式定档，预告片中高度还原的唐代服饰、建筑与器物，让"考据党"们集体沸腾。',
    content: [
      '古装历史剧《风起长安》宣布定档，同步释出的首支预告以极具质感的画面引发广泛关注。',
      '据美术团队介绍，剧组为还原盛唐气象，仅服装就制作了上千套，纹样均参考出土文物与古籍图谱进行复原，建筑场景则采用实景搭建与数字技术结合的方式呈现。',
      '"我们希望在好看之外，也能经得起放大镜式的观看。"总美术指导陆昭表示，团队甚至为不同身份的配角设计了差异化的器物细节。',
      '随着预告片上线，关于唐代服饰形制、礼仪制度的讨论在网络上持续升温，不少历史博主自发整理起画面中的考据彩蛋，让剧集在开播之前就收获了满满期待。',
    ],
  },
  {
    id: 4,
    title: '第 XX 届国际电影节公布主竞赛入围名单，亚洲影片表现亮眼',
    subtitle: '多部华语作品入选，类型呈现多样化',
    category: '行业观察',
    date: '2026-09-05',
    author: '周樾',
    cover:
      'https://readdy.ai/api/search-image?query=Film%20festival%20red%20carpet%20at%20dusk%2C%20elegant%20crowd%20silhouettes%20before%20a%20glowing%20venue%2C%20warm%20gold%20and%20deep%20navy%20tones%2C%20editorial%20photography%2C%20landscape%20composition&width=800&height=500&seq=news-4&orientation=landscape',
    summary:
      '本届电影节主竞赛单元名单揭晓，多部亚洲影片入围，题材横跨科幻、家庭与纪录，类型更加多元。',
    content: [
      '一年一度的国际电影节日前公布主竞赛单元入围名单，共有多部亚洲影片跻身其中，成为本届的一大看点。',
      '从公布的名单来看，入围作品在题材上呈现明显的多样化趋势，既有探讨科技伦理的科幻片，也有聚焦普通人生活的家庭故事，以及关注自然的纪录作品。',
      '影评人指出，近两年国际影展对亚洲创作者的关注持续上升，尤其在类型融合与在地表达方面，出现了不少令人耳目一新的尝试。',
      '本届电影节将于下月开幕，影视仓也将持续跟进红毯、首映与获奖动态，为影迷带来一线报道。',
    ],
  },
  {
    id: 5,
    title: '治愈系日剧《春日邮局》为什么让人一集一集停不下来',
    subtitle: '慢节奏里的治愈力，藏在手写信的褶皱里',
    category: '深度解读',
    date: '2026-08-29',
    author: '苏木',
    cover:
      'https://readdy.ai/api/search-image?query=Cozy%20small%20town%20post%20office%20among%20cherry%20blossoms%2C%20soft%20pastel%20pink%20and%20cream%20tones%2C%20gentle%20sunlight%2C%20warm%20editorial%20photography%2C%20landscape%20composition&width=800&height=500&seq=news-5&orientation=landscape',
    summary:
      '没有强冲突、没有大反转，《春日邮局》却靠着细腻的日常与文字魅力，成为许多人睡前的"电子布洛芬"。',
    content: [
      '在追求强情节的当下，《春日邮局》显得有些"反潮流"。它把镜头对准海边小镇的一间旧邮局，用一封封代写的书信串起邻里之间的故事。',
      '该剧最打动人的，或许正是它对"缓慢"的尊重。台词不疾不徐，画面留有大段安静的空白，让观众得以喘息。',
      '有观众评论说："看这部剧就像给情绪做了一次整理，很多说不出口的心事，都被信里的字替我说了。"',
      '从这个意义上说，《春日邮局》提供的不仅是一段故事，更是一种被允许慢下来的生活姿态。',
    ],
  },
  {
    id: 6,
    title: '动画电影《机甲纪元》发布新预告，机甲设计图首次公开',
    subtitle: '手绘质感与三维技术融合，情怀与野心并存',
    category: '电影资讯',
    date: '2026-08-22',
    author: '影视仓编辑部',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20mecha%20concept%20art%2C%20giant%20robot%20silhouette%20against%20a%20fiery%20sunset%20sky%2C%20vivid%20orange%20and%20steel%20blue%20tones%2C%20dynamic%20illustration%2C%20landscape%20composition&width=800&height=500&seq=news-6&orientation=landscape',
    summary:
      '《机甲纪元》全新预告公开，多支主力机甲的设计线稿同步释出，细腻的机械结构让硬核粉丝大呼过瘾。',
    content: [
      '备受期待的动画电影《机甲纪元》日前发布第二支预告，除动作场面外，还首次公开了多台主力机甲的设计线稿。',
      '导演新田凉介表示，团队在三维技术的基础上刻意保留了手绘的线条质感，希望让机械既有重量感，也不失"人味"。',
      '预告片中，少年驾驶员与上古机甲在废墟都市中并肩作战的画面，配合那段熟悉的旋律，勾起了不少观众的动画情怀。',
      '据悉，影片还将推出幕后艺术设定集，收录大量未被采用的设计方案，供硬核爱好者收藏。',
    ],
  },
  {
    id: 7,
    title: '纪录剧集《雨林秘境》上线，四年时间记录未知生命',
    subtitle: '镜头之外，是极致的耐心',
    category: '深度解读',
    date: '2026-08-15',
    author: '顾野',
    cover:
      'https://readdy.ai/api/search-image?query=Lush%20emerald%20rainforest%20canopy%20with%20sunbeams%20through%20mist%20and%20colorful%20birds%2C%20rich%20green%20and%20amber%20tones%2C%20nature%20documentary%20photography%2C%20landscape%20composition&width=800&height=500&seq=news-7&orientation=landscape',
    summary:
      '为了几个从未被记录过的镜头，摄制团队在雨林里驻守了四年——这部纪录剧集讲述的是耐心本身。',
    content: [
      '《雨林秘境》上线后迅速收获高口碑，而比画面更令人震撼的，是镜头背后的时间成本。',
      '据制作方介绍，团队为了记录某种罕见鸟类的求偶行为，在同一片区域连续蹲守了超过400天。"自然不会配合你的档期，你只能等。"一位摄影师说。',
      '全片采用高规格摄影设备拍摄，力求在保留真实的前提下，呈现雨林最细腻的光影与色彩。',
      '这部作品也提醒观众，在人类之外，世界还存在着数量庞大却鲜为人知的生命，它们同样值得被看见。',
    ],
  },
  {
    id: 8,
    title: '都市剧《都市浮光》收官：我们为什么总在别人的故事里看到自己',
    subtitle: '关于理想、友情与成长的当代样本',
    category: '深度解读',
    date: '2026-08-08',
    author: '林观影',
    cover:
      'https://readdy.ai/api/search-image?query=Neon%20city%20street%20at%20dusk%20with%20young%20professionals%20walking%20and%20rain%20reflections%2C%20warm%20orange%20and%20slate%20blue%20tones%2C%20cinematic%20urban%20photography%2C%20landscape%20composition&width=800&height=500&seq=news-8&orientation=landscape',
    summary:
      '《都市浮光》用三个年轻人的困境与选择，照见了无数在城市里努力生活的人。',
    content: [
      '都市情感剧《都市浮光》日前收官，故事围绕三个在都市打拼的年轻人被同一场项目危机捆在一起的经历展开。',
      '该剧没有刻意制造爽感，而是把大量篇幅留给了角色的犹疑与挣扎。正是这种不完美，让许多观众产生了强烈代入感。',
      '"它没有告诉我该怎么办，只是让我知道，原来不止我一个人会这样。"一位网友在讨论区的留言获得了高赞。',
      '或许这正是都市题材的魅力所在——它让每个奔跑的人，都能在别人的故事里，短暂地喘一口气。',
    ],
  },
  {
    id: 9,
    title: '九月影视前瞻：科幻、悬疑、治愈齐上阵，这份片单请收好',
    subtitle: '本月最值得期待的十部作品',
    category: '行业观察',
    date: '2026-09-01',
    author: '影视仓编辑部',
    cover:
      'https://readdy.ai/api/search-image?query=Stylish%20monthly%20movie%20preview%20collage%2C%20dark%20cinema%20atmosphere%20with%20warm%20spotlight%2C%20deep%20navy%20and%20amber%20tones%2C%20editorial%20photography%2C%20landscape%20composition&width=800&height=500&seq=news-9&orientation=landscape',
    summary:
      '从硬核科幻到治愈日常，九月的影视档期可谓类型齐全。影视仓为你整理了本月最值得关注的十部作品。',
    content: [
      '进入九月，影视市场迎来了新一轮内容高峰，科幻、悬疑、治愈等类型作品密集登场，为观众提供了丰富的选择。',
      '在电影方面，多部科幻与动作题材作品将陆续上映；而在剧集领域，悬疑与都市情感题材依旧是主力，同时也出现了不少小而美的治愈系作品。',
      '影视仓建议，不妨根据自己的心情挑选作品：想被震撼，就看科幻；想动脑，就选悬疑；想放松，那就留给治愈。',
      '本月影视仓也将持续更新推荐与资讯，帮助你更快找到属于自己的那一部。',
    ],
  },
];

export const newsCategories = ['电影资讯', '剧集动态', '行业观察', '深度解读'];